import { render, staticRenderFns } from "./addDictionariesCategory.vue?vue&type=template&id=3c6d823e&scoped=true&"
import script from "./addDictionariesCategory.vue?vue&type=script&lang=js&"
export * from "./addDictionariesCategory.vue?vue&type=script&lang=js&"
import style0 from "./addDictionariesCategory.vue?vue&type=style&index=0&id=3c6d823e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d823e",
  null
  
)

export default component.exports